import hearticon from '../../imgs/icons/heart-icon.png'

export default function HeartIcon() {
    return (
      <div>
        <img id = "hearticon" src= {hearticon} alt = "heart-icon"/>
      </div>
    );
  }
  